export const actionTypes = {
  selectRevision: "PATIENTS_SELECT_REVISION",
  addRevisionItem: "PATIENTS_ADD_REVISION_ITEM",
  removeRevisionItem: "PATIENTS_REMOVE_REVISION_ITEM"
};
